import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface CreateGotyDialogProps {
  open: boolean;
  onClose: () => void;
}

const CreateGotyDialog: React.FC<CreateGotyDialogProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const [year, setYear] = useState<number>(currentYear);
  const [isMyGoty, setIsMyGoty] = useState<boolean>(false);

  const handleCreate = () => {
    // MyGOTYかどうかでURLパスを分ける
    const path = isMyGoty ? `/mygoty/${year}/edit` : `/goty/${year}/edit`;
    navigate(path);
    onClose();
  };

  const handleClose = () => {
    // ダイアログを閉じる際にリセット
    setYear(currentYear);
    setIsMyGoty(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>新規GOTY作成</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <TextField
            label="年"
            type="number"
            value={year}
            onChange={(e) => setYear(parseInt(e.target.value) || currentYear)}
            fullWidth
            sx={{ mb: 2 }}
            inputProps={{
              min: 2024,
              max: 2100,
            }}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={isMyGoty}
                onChange={(e) => setIsMyGoty(e.target.checked)}
              />
            }
            label={
              <Box>
                <Typography variant="body2">MyGOTY（年制約なし）</Typography>
                <Typography variant="caption" color="text.secondary">
                  その年に遊んだゲームを選択できます
                </Typography>
              </Box>
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>キャンセル</Button>
        <Button onClick={handleCreate} variant="contained">
          作成
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateGotyDialog;
